
























import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';
import { Validation } from 'vuelidate';

@Component({
	components: {},
})
export default class AddressSuggest extends Vue {
	@PropSync('adr') public localAdr!: object;

	@Prop(Object)
	public readonly validator?: Validation;

	get validationState() {
		if (this.validator) {
			return this.validator.fullAdr.$dirty && this.validator.fullAdr.$invalid;
		}
		return null;
	}
	@Prop(Boolean)
	public readonly disabled?: boolean;

	public setPlace(place: any) {
		if (this.validator) {
			this.validator.$touch();
		}

		if (place) {
			this.localAdr.address.fullAdr = (
				(place.adr_address || place.formatted_address) ??
				''
			).replace(/(<([^>]+)>)/gi, '');
			this.localAdr.address.rawAddress = place;

			const lat =
				typeof place.geometry.location.lat === 'function'
					? place.geometry.location.lat()
					: place.geometry.location.lat;
			const lng =
				typeof place.geometry.location.lng === 'function'
					? place.geometry.location.lng()
					: place.geometry.location.lng;
			this.localAdr.address.location = `${lat}, ${lng}`;
		}
	}

	public clearAddress() {
		this.localAdr.address = { fullAdr: '', rawAddress: {}, location: '' };
		this.$emit('clear');
	}
}
